import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TransactionDateChangeHistoryComponent } from './transaction-date-change-history.component';
import { TooltipModule } from '../tooltip/tooltip.module';
import { DialogModule } from '../dialog/dialog.module';
import { FormattedDateModule } from '../../pipes/formatted-date/formatted-date.module';
import { FormattedDatePipe } from '../../pipes/formatted-date/formatted-date.pipe';
import { ButtonModule } from '../button/button.module';



@NgModule({
  declarations: [TransactionDateChangeHistoryComponent],
  imports: [
    CommonModule,
    TooltipModule,
    DialogModule,
    FormattedDateModule,
    ButtonModule
  ],
  providers: [FormattedDatePipe],
  exports: [TransactionDateChangeHistoryComponent]
})
export class TransactionDateChangeHistoryModule { }
